/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import PropTypes from 'prop-types';

import './AppHeader.styles.scss';

import UI_CONSTANTS from '../../constants/uiConstants';
import { updateStatusBarColor } from '../../utilities/MobileUtil';

class AppHeader extends React.Component {

  getBackgroundColor() {
    switch (this.props.colorThemeName) {
      case 'group':
        return 'theme-group base background';
      case 'backpack':
        return 'bkgd-color-backpack-theme-base';
      case 'none':
        updateStatusBarColor(this.props.colorTheme.base_color);
        return '';
      case 'profile':
      default:
        updateStatusBarColor(this.props.colorTheme.base_color);
        return 'profile-background-color';
    }
  }

  render() {
    const backgroundColor = this.getBackgroundColor();

    return (
      <div id="cmp-app-header" className={`cmp-app-header is-animated ${backgroundColor} ${this.props.className}`} style={{ paddingTop: UI_CONSTANTS.statusBarHeight, ...this.props.style }}>
        {this.props.children}
      </div>
    );
  }
}
AppHeader.propTypes = {
  children: PropTypes.any,
  colorThemeName: PropTypes.oneOf(['profile', 'group', 'backpack', 'none']),
  colorTheme: PropTypes.any,
  paddingTop: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object,
};
AppHeader.defaultProps = {
  colorThemeName: 'profile',
  className: '',
  style: {},
};

export default AppHeader;
